import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' // 引入Vuex 全局store

import $ from 'jquery' // 配置jquery
import iView from 'iview' // 引入iView
import './assets/style/index.less' // 引入全局样式
import {
  axios
} from 'axios'

import addressData from '@/../static/address'
// 引入二维码生成插件
import VueQriously from 'vue-qriously'
// 引入视频播放组件
// import VueVideoPlayer from 'vue-video-player'
// require videojs style
// import 'video.js/dist/video-js.css'
// 引入复制到剪贴板插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueQriously)

// import VueLazyload from 'vue-lazyload'  //引入这个懒加载插件

// Vue.use(VueLazyload, {
//     preLoad: 1.3,
//     attempt: 1,
//     listenEvents: [ 'scroll' ]
//   })

Vue.use(VueClipboard)

Vue.use(iView)
// Vue.use(VueVideoPlayer
//   /* {
//          options: global default options,
//          events: global videojs events
//        } */
// )
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  mounted () {
    // 引入外部 iconfont.js 文件 svg 使用      iconfont.css文件在index.less里面引入
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = '//at.alicdn.com/t/font_991683_k8n2yxevvl.js'
    document.body.appendChild(s)

    // 把地域信息放在全局
    this.$store.dispatch('setAddressData', addressData)
    this.$Message.config({ // 配置全局的气泡提示时间延迟
      top: 50,
      duration: 3
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js